import { kemsuWebServer } from "~/shared/config"

/**
 * Url системы на KemsuWeb
 */
export const kemsuWebSystemUrl = `https://${kemsuWebServer}.kemsu.ru`

/**
 * Url префикс для страниц с помощью которых реализуется обмен данными с системой на KemsuWeb
 */
export const kemsuWebSystemBridgeUrl = `https://${kemsuWebServer}.kemsu.ru/dekanat/eios-next-bridge`
